import util from '@/util'

const mappingTabEventLabel = {
  feedback: 'Feedback',
  profile: 'Account',
  slide: 'Presentation',
  lookback: 'Lookback',
}
const setPresentationAction = (context, payload) => {
  context.commit('setPresentation', payload)
}

const patchPresentationAction = (context, payload) => {
  context.commit('patchPresentation', payload)
}

/**
 * @param {Object} store
 * @param {String|Object} payload
 */

const setActiveTabAction = (store, payload) => {
  let eventName = 'Main screen > Switch tab'
  let activeTab = payload
  let trackingProps = {}

  if (typeof payload === 'object') {
    const { activeTab: tab, trackingProps: props } = payload
    activeTab = tab

    if (props && props.eventName) {
      const { eventName: name, ...rest } = props
      eventName = name
      trackingProps = { ...rest }
    } else {
      trackingProps = { ...props }
    }
  }

  store.commit('setActiveTab', payload.activeTab || payload)
  util.ga4Track(
    eventName,
    {
      eventLabel: mappingTabEventLabel[activeTab],
      ...trackingProps,
    },
  )
}

export default {
  setPresentationAction,
  setPresentation: setPresentationAction,
  patchPresentationAction,
  setActiveTabAction,
}
